import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";

const BATCH_EQUIPMENT_URL = `${BACKEND_DOMAIN}/sandbox/batch-equipment-intelligence`;

export interface BatchEquipmentIntelligenceResponse {
    batch_id: string;
    message: string;
}

const usePortfolioBatchEquipmentIntelligenceMutation = () => {
    const alert = useAlert();
    const accessToken = useAccessToken();

    return useMutation({
        mutationFn: async (): Promise<BatchEquipmentIntelligenceResponse> => {
            const response = await fetch(BATCH_EQUIPMENT_URL, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
            });

            if (!response.ok) {
                let message = `Error ${response.status}`;
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    try {
                        const body = await response.json();
                        if (typeof body?.error === "string") message = body.error;
                    } catch {
                        // use default message
                    }
                }
                throw new Error(message);
            }

            return response.json() as Promise<BatchEquipmentIntelligenceResponse>;
        },
        onSuccess: () => {
            alert.success(
                "Generation task sent. You will receive an email when the results are ready."
            );
        },
        onError: (error) => {
            const message =
                error instanceof Error ? error.message : String(error);
            showMutationAlert(message, alert);
        },
    });
};

export default usePortfolioBatchEquipmentIntelligenceMutation;
